import { render } from "./TheFooter.vue?vue&type=template&id=3c4d6d1e&scoped=true"
import script from "./TheFooter.vue?vue&type=script&lang=js"
export * from "./TheFooter.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-3c4d6d1e"

export default script